<template>
  <div class="irp-overview-tab" data-testid="irp-overview-tab">Overview</div>
</template>
